import * as Ajax from '../utils/ajax.js';
import * as utils from '../utils.js';
import * as $ from 'jquery';
import { post } from '../utils/ajax.js';

export const productWhoLikes = async () => {

    const contentModal = document.querySelector('.js-who-likes-content');
    const isOwner = utils.config.is_owner;
    const userLoggedName = utils.config.user.username;
    const alertSuccess = document.querySelector('.js-who-like-alert');
    const alertSuccessUserName = document.querySelector('.js-who-like-alert-user');
    const alertFollowSuccess = document.querySelector('.js-who-like-follow-alert');
    const alertFollowSuccessUserName = document.querySelector('.js-who-like-follow-alert-user');
    const formCommentTemplate = document.querySelector('.js-who-likes-comment-form');
    const alertError = document.querySelector('.js-who-like-stopword-alert');
    const alertErrorMessage = document.querySelector('.js-who-like-stopword-alert-message');
    const initialPage = 1;
    const translations = JSON.parse(formCommentTemplate?.dataset.translations ?? '{}');
    const disabledFollowClass = ['text-grey-400', 'font-weight-normal'];
    const toggleReplyClass = ['icon-close', 'text-right'];

    let successPostModal = false;

    const whoLikesUsers = async(page) => await Ajax.get(`/api/v4/products/${utils.config.product_id}/likes/users`, { page, size: 200 }, true, true);

    let { page, _embedded: { items } = {} } = await whoLikesUsers(initialPage) || {};
    let { number: currentPage, total_pages: totalPages } = page;
    let lastElement;

    const defaultImage = '/assets/img/avatar-default.svg';

    const followUser = (userId) => post(`/api/v5/user/${userId}/follow`, {}, true, false).then(response => response);

    const userWhoLikesContent = (items) => `
        ${ items.map(( item, index )  => `
            ${ userWhoLikesRow( item, index ) }
        `).join("") }
    `;

    const ctaReplyButton = (index, follow, following) => `
        ${ follow(following) }
        <button
                type="button"
                data-toggle="collapse"
                data-target="#who-likes-${ index }"
                aria-expanded="false"
                aria-controls="who-likes-${ index }"
                class="btn text-primary-500 btn-loading border-0 p-0 ml-2 js-who-likes-reply-btn text-center">
                ${ translations.responder }
            </button>
    `;

    const ctaFollowButton = (following) => `
        <button
            type="button"
            class="btn text-primary-500 border-0 p-0 ml-2 js-who-likes-follow-btn text-center ${ following ? 'text-grey-400 font-weight-normal' : ''} ${utils.config.user.isBorderCrossing ? 'd-none' : ''}"
                ${ following ? 'disabled' : ''}>
                ${ following ? translations.siguiendo : translations.seguir}
        </button>
    `;

    const userWhoLikesRow = ({ following, image, username, id }, index) => `
      <div class="col-12 pt-0 pb-3 js-who-likes-row" data-like-owner="${ username }" data-like-owner-id="${ id }">
        <div class="d-flex">
            <a href="/u/${ username }" class="mr-2">
                <img src="${ image ? image : defaultImage }" onerror="this.onerror=null; this.src='/assets/img/broken-img.svg'" height="33" width="33" class="user-avatar mr-2">
            </a>
            <div class="w-100 d-flex align-items-center">
                <div class="d-flex w-100 align-items-start">
                    <div class="pr-2 flex-fill">
                        <a href="/u/${ username }" class="caption-md flex-grow-1 text-break mr-3">
                            <b class="js-who-like-owner">${ username }</b>
                        </a>
                    </div>
                    ${ isOwner && username !== userLoggedName ?
                        `<div class="d-flex mr-0 mr-md-0 who-likes-cta">
                            ${ (Object.values(utils.config.username_citations_by_lister).indexOf(username)) > -1 
                                ? `${ctaFollowButton(following)} <span class="text-grey-400 ml-2 caption-md text-center">${ translations.enviado }</span>` 
                                : ctaReplyButton(index, ctaFollowButton, following)
                            }
                        </div>`
                        :
                        `<div class="d-flex mr-0 mr-md-0 who-likes-cta">
                            ${ username === userLoggedName || utils.config.user.isBorderCrossing ? '' : ctaFollowButton(following) }
                        </div>`
                    }
                </div>
            </div>
        </div>
        <div class="collapse js-who-likes-collapse mx-n3" id="who-likes-${ index }">
            <div class="d-flex flex-column"></div>
        </div>
      </div>
    `;

    contentModal && (contentModal.innerHTML = userWhoLikesContent(items));

    const removeElement = ( element, speed ) => {
        window.setTimeout(() => {
            element.style.transition = `opacity 500ms ${ speed }ms ease`;
            element.style.opacity = 0;

            element.addEventListener("transitionend", () => {
                element.classList.add('d-none');
                element.style.opacity = 1;
            }, false);

         }, 150);
    }

    const whoLikesRows = document.querySelectorAll('.js-who-likes-row');

    whoLikesRows?.forEach((row) => {
        const likeOwnerName = row.dataset.likeOwner;
        const likeOwnerId = row.dataset.likeOwnerId;
        const whoLikesCollapse = row.querySelector('.js-who-likes-collapse');
        const whoLikesReplyBtn = row.querySelector('.js-who-likes-reply-btn');
        const whoLikesFollowBtn = row.querySelector('.js-who-likes-follow-btn');
        const userNameLikesOwner = row.querySelector('.js-who-like-owner');
        let textAreaComment, sendCommentBtn, formComment;

        // Clone and append template
        whoLikesCollapse?.appendChild(formCommentTemplate?.content.cloneNode(true));

        sendCommentBtn = row.querySelector('.js-send-comment-btn');
        textAreaComment = row.querySelector('textarea[name="txtcomment"]');
        formComment = row.querySelector('.js-comment-product');

        if (textAreaComment) {
            textAreaComment.placeholder = `${ translations.escribele } @${likeOwnerName}`;
        }

        whoLikesReplyBtn?.addEventListener('click', () => {

            const likeButton = whoLikesReplyBtn.parentElement?.childNodes[1];

            if (whoLikesReplyBtn.textContent?.trim().toLowerCase() === 'responder') {
                userNameLikesOwner && (userNameLikesOwner.textContent = `@${likeOwnerName},`);
                whoLikesReplyBtn.textContent = '';
                whoLikesReplyBtn.classList.remove('text-primary-500');
                whoLikesReplyBtn.classList.add(...toggleReplyClass);
                likeButton?.classList.contains('js-who-likes-follow-btn') && likeButton.classList.add('d-none');

            } else {
                userNameLikesOwner && (userNameLikesOwner.textContent = likeOwnerName);
                whoLikesReplyBtn.textContent = translations.responder;
                whoLikesReplyBtn.classList.add('text-primary-500');
                whoLikesReplyBtn.classList.remove(...toggleReplyClass);
                likeButton?.classList.contains('js-who-likes-follow-btn') && !utils.config.user.isBorderCrossing && likeButton.classList.remove('d-none');
            }
        })

        whoLikesFollowBtn?.addEventListener('click', () => {
            followUser(likeOwnerId);

            alertFollowSuccessUserName && (alertFollowSuccessUserName.innerHTML = `@${likeOwnerName}`);
            alertFollowSuccess?.classList.remove('d-none');

            whoLikesFollowBtn.textContent = translations.siguiendo;
            whoLikesFollowBtn.classList.add(...disabledFollowClass);
            whoLikesFollowBtn.disabled = true;

            removeElement(alertFollowSuccess, 3000);
        })

        sendCommentBtn?.addEventListener('click', () => {
            textAreaComment && (textAreaComment.value = `@${likeOwnerName} ${textAreaComment.value.trim()}`);
        })
    });

    document.addEventListener('commentPost', (e) => { 
        const rowSelected = e.detail.element.closest('.js-who-likes-row');
        const textAreaSelected = rowSelected?.querySelector("[name='txtcomment']");
        if (rowSelected !== null && e.detail.comment.commentId) {
            const whoLikesCollapse = rowSelected.querySelector('.js-who-likes-collapse');
            const whoLikesReplyBtn = rowSelected.querySelector('.js-who-likes-reply-btn');
            const userNameLikesOwner = rowSelected.querySelector('.js-who-like-owner');
            const likeOwnerName = rowSelected.dataset.likeOwner;
            
            $(whoLikesCollapse).collapse('hide');

            userNameLikesOwner && (userNameLikesOwner.textContent = likeOwnerName);

            whoLikesReplyBtn && (whoLikesReplyBtn.textContent = translations.enviado);
            whoLikesReplyBtn?.classList.add(...disabledFollowClass);
            whoLikesReplyBtn?.classList.remove(...toggleReplyClass);
            whoLikesReplyBtn && whoLikesReplyBtn.setAttribute("style", "pointer-events: none");
            if (!utils.config.user.isBorderCrossing) {
                whoLikesReplyBtn?.parentElement?.childNodes[1]?.classList.remove('d-none');
            }

            alertSuccessUserName && (alertSuccessUserName.innerHTML = `@${likeOwnerName}`);
            alertSuccess?.classList.remove('d-none');
            removeElement(alertSuccess, 3000);

            successPostModal = true;

        } else if (e.detail.comment.message) {

            alertError?.classList.remove('d-none');
            alertErrorMessage && (alertErrorMessage.innerHTML = e.detail.comment.message);
            textAreaSelected && (textAreaSelected.value = '');
            removeElement(alertError, 3000);
        } else {

            alertError?.classList.remove('d-none');
            alertErrorMessage && (alertErrorMessage.innerHTML = 'Ha ocurrido un error al intentar realizar el comentario.');
            textAreaSelected && (textAreaSelected.value = '');
            removeElement(alertError, 3000);
            }
        } 
    );

    $(document).on('hidden.bs.modal','#modal-who-like-product', () => {
        if (successPostModal) window.location.reload();
    });

    lastElement = contentModal?.firstElementChild?.lastElementChild;

    const addNewUserInfo = async (target) => {

        ({ page, _embedded: { items } = {} } = await whoLikesUsers(++currentPage) || {});
        ({ number: currentPage, total_pages: totalPages } = page);

        target.insertAdjacentHTML('beforeend', userWhoLikesContent(items));

        observer.unobserve(target);
        observer.observe(lastElement);
    }

    const observer = new IntersectionObserver(entries => {
        const lastUserInfo = entries[0];
        if ( currentPage === totalPages ) {
            observer.disconnect();
            return
         }

        if (!lastUserInfo.isIntersecting) return;
        addNewUserInfo(contentModal)
    },{ root: null })

    // Added observer only when is posible paginate
    currentPage < totalPages && observer.observe(lastElement);
}